<template>
  <div
    class="center-vertical relative bg-gradient-to-br from-gray-700 to-gray-800 rounded-lg shadow-md w-full max-w-md"
  >
    <div class="blue h-full w-2 bg-[#3c8dbc] border border-[#367fa9] absolute left-0 top-0"></div>
    <div class="inner relative left-8 top-0 p-6 pl-1 w-[490px] h-full bg-gradient-to-br from-gray-700 to-gray-800">
      <div class="header w-full border-b border-white pb-5 flex mb-6">
        <div class="colleft flex">
          <div class="logo float-left flex items-center mr-5">
            <img src="../../assets/img/logos/newLogo.png" alt="MyABFT" class="h-12 w-auto"/>
          </div>
        </div>
        <div class="colright flex">
          <div class="title text-2xl font-bold uppercase text-white text-shadow">
            <div class="header">MYABFT</div>
            <div class="subtitle text-lg font-light text-white">CREATION DE COMPTE</div>
          </div>
        </div>
      </div>
      <div v-if="hasErrors" class="bg-red-500 text-white text-center p-4 mb-4 rounded">
        <p v-for="(error, index) in errors" :key="index">{{ error }}</p>
      </div>

      <form class="body" @submit.prevent="submitForm">
        <div class="mb-4">
          <label for="license" class="block text-sm font-medium mb-1">Licence N°</label>
          <input
            type="text"
            id="license"
            v-model="form.license"
            placeholder="Licence N°"
            class="inputLogin w-full px-4 py-2 rounded-none bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>
        <div class="mb-4 relative">
          <label for="dob" class="block text-sm font-medium mb-1">Date de naissance</label>
          <input
            type="date"
            id="dob"
            v-model="form.dob"
            placeholder="Date de naissance"
            class="inputLogin w-full px-4 py-2 rounded-none bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>
        <div class="mb-4 relative">
          <label for="code" class="block text-sm font-medium mb-1">Code unique reçu par e-mail</label>
          <input
            type="text"
            id="code"
            v-model="form.code"
            placeholder="Code d'activation"
            class="inputLogin w-full px-4 py-2 rounded-none bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>
        <div class="mb-6">
          <button
            type="submit"
            :disabled="!isFormValid"
            class="btn-primary w-full py-2 px-4 bg-[#3c8dbc] border border-[#367fa9] hover:bg-[#367fa9] rounded-lg font-bold text-white transition duration-300"
            :class="{ 'opacity-50 cursor-not-allowed': !isFormValid }"
          >
            Créer mon compte
          </button>
        </div>
      </form>
      <div class="bodyBottom text-center mt-6">
        <a href="/account/recover" class="hover:no-underline text-white underline text-xs font-normal">
          Déjà un compte ? Cliquez ici pour réinitialiser votre mot de passe.
        </a>
      </div>
      <div class="bodyBottom text-right mt-6">
        <a href="http://www.abft.be" class="hover:no-underline text-white underline text-sm font-normal">Retour au
          site</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        license: '',
        dob: '',
        code: '',
      },
      errors: [],
    };
  },
  computed: {
    isFormValid() {
      return (
        this.form.license.trim() !== '' &&
        this.form.dob.trim() !== '' &&
        this.form.code.trim() !== ''
      );
    },
    hasErrors() {
      return this.errors.length > 0;
    },
  },
  methods: {
    checkFields() {
      this.errors = [];
      if (!this.form.license) {
        this.errors.push('Licence N° est requis.');
      }
      if (!this.form.dob) {
        this.errors.push('Date de naissance est requise.');
      }
      if (!this.form.code) {
        this.errors.push('Code unique est requis.');
      }
    },
    submitForm() {
      this.checkFields();
      if (this.errors.length === 0) {
        // Submit the form data
        console.log('Formulaire soumis avec succès', this.form);
      }
    },
  },
};
</script>

<style scoped>
@import 'https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css';
body {
  background-image: url('../../assets/img/backgrounds/bg5.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.title {
  font-size: 23px;
  text-transform: uppercase;
  text-shadow: 1px 1.7px 5px rgba(0, 0, 0, 0.75);
  font-weight: 700;
}

.subtitle {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.icon-calendar {
  color: white;
  cursor: pointer;
}

input[type='date']::-webkit-calendar-picker-indicator {
  filter: invert(1);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Member/NoMemberLinked.vue